'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FlashMessageTypes = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _desc2, _value2, _class3, _descriptor13;

var _mobx = require('mobx');

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

// ID used for React key.
var _idCounter = 1;

var DEFAULT_DISMISS_TIME = 3000;

var FlashMessageTypes = exports.FlashMessageTypes = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  ERROR: 'error'
};

/**
 * A single flash message with a fluent API.
 */
var FlashMessage = (_class =

/**
 * Constructor sets the initial stuff.
 * If autoDismiss is set, the message with dismiss after
 * the specified amount of milliseconds.
 *
 * @param {object} opts
 * Will be set on the instance.
 */
function FlashMessage(opts) {
  (0, _classCallCheck3.default)(this, FlashMessage);

  _initDefineProp(this, 'message', _descriptor, this);

  _initDefineProp(this, 'isShowing', _descriptor2, this);

  _initDefineProp(this, 'inProgress', _descriptor3, this);

  _initDefineProp(this, 'type', _descriptor4, this);

  _initDefineProp(this, 'show', _descriptor5, this);

  _initDefineProp(this, 'dismiss', _descriptor6, this);

  _initDefineProp(this, 'clearDismissTimer', _descriptor7, this);

  _initDefineProp(this, 'autoDismiss', _descriptor8, this);

  _initDefineProp(this, 'set', _descriptor9, this);

  _initDefineProp(this, 'progress', _descriptor10, this);

  _initDefineProp(this, 'done', _descriptor11, this);

  _initDefineProp(this, 'failed', _descriptor12, this);

  opts = (0, _extends3.default)({}, (0, _isString2.default)(opts) ? { message: opts } : opts, {
    id: _idCounter++
  });

  var _opts = opts,
      autoDismiss = _opts.autoDismiss,
      other = (0, _objectWithoutProperties3.default)(_opts, ['autoDismiss']);

  this.set(other);
  if (autoDismiss && !opts.inProgress) {
    this.autoDismiss(autoDismiss);
  }
}

/**
 * Shows the message again (if it was dismissed before).
 */


/**
 * Dismisses the message.
 */


/**
 * Clears the dismiss timeout.
 *
 * @return {FlashMessage}
 * The instance.
 */


/**
 * Sets up the message to auto dismiss.
 *
 * @param  {Number} ms
 * How long till it is dismissed?
 *
 * @return {FlashMessage}
 * The instance.
 */


/**
 * Sets the given opts directly on the instance.
 *
 * @param {object} opts
 * Options to set.
 *
 * @return {FlashMessage}
 * The instance.
 */


/**
 * Marks this message as being an in-progress type.
 *
 * @param  {string} message
 * Optional message to set.
 *
 * @return {FlashMessage}
 * This instance.
 */


/**
 * Marks the message as done (sets inProgress to false).
 * Basically like `set`, but with an automatic inProgress = false.
 *
 * @param  {object}   opts
 * Additional things to set.
 *
 * @return {FlashMessage}
 * The instance.
 */


/**
 * Marks the message as done (sets inProgress to false).
 * Basically like `set`, but with an automatic inProgress = false.
 *
 * @param  {object}   opts
 * Additional things to set.
 *
 * @return {FlashMessage}
 * The instance.
 */
, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'message', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'isShowing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'inProgress', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return FlashMessageTypes.DEFAULT;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'show', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this = this;

    return function () {
      _this.isShowing = true;
      return _this;
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'dismiss', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      _this2.isShowing = false;
      return _this2;
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'clearDismissTimer', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function () {
      clearTimeout(_this3._timeout);
      return _this3;
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'autoDismiss', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function () {
      var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_DISMISS_TIME;

      _this4.clearDismissTimer();
      _this4._timeout = setTimeout(function () {
        _this4.dismiss();
      }, ms);
      return _this4;
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'set', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (opts) {
      (0, _assign2.default)(_this5, opts);
      return _this5;
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'progress', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function (message) {
      _this6.set({
        inProgress: true,
        message: message || _this6.message
      });
      return _this6;
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'done', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this7 = this;

    return function (opts) {
      // If passed just the message, make it an options object.
      if (typeof opts === 'string') {
        opts = { message: opts };
      }

      _this7.set((0, _extends3.default)({}, opts, {
        inProgress: false,
        type: FlashMessageTypes.SUCCESS
      }));
      return _this7;
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'failed', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this8 = this;

    return function (opts) {
      // If passed just the message, make it an options object.
      if (typeof opts === 'string') {
        opts = { message: opts };
      }

      _this8.set((0, _extends3.default)({}, opts, {
        inProgress: false,
        type: FlashMessageTypes.ERROR
      }));
      return _this8;
    };
  }
})), _class);

/**
 * The Flash Message store.
 */

var FlashMessageStore = (_class3 = function () {
  function FlashMessageStore() {
    (0, _classCallCheck3.default)(this, FlashMessageStore);

    _initDefineProp(this, 'flashes', _descriptor13, this);
  }

  (0, _createClass3.default)(FlashMessageStore, [{
    key: 'create',
    value: function create(opts) {
      var message = new FlashMessage(opts);
      this.flashes.push(message);
      return message;
    }

    /**
     * Clears the flashes.
     */

  }, {
    key: 'clear',
    value: function clear() {
      this.flashes.replace([]);
      return this;
    }
  }, {
    key: 'showingFlashes',


    /**
     * Computes the flashes to show.
     */
    get: function get() {
      return this.flashes.filter(function (x) {
        return x.isShowing;
      }).reverse();
    }

    /**
     * Creates and adds a new flash message.
     */

  }]);
  return FlashMessageStore;
}(), (_descriptor13 = _applyDecoratedDescriptor(_class3.prototype, 'flashes', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class3.prototype, 'showingFlashes', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'showingFlashes'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'create', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'create'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'clear', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'clear'), _class3.prototype)), _class3);
exports.default = FlashMessageStore;
//# sourceMappingURL=FlashMessageStore.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/FlashMessages/FlashMessageStore.js
// module id = 252
// module chunks = 0